import { WORDPRESS_API } from "shared/constants/api";

const shuffleItems = (items) => {
  const shuffledItems = [...items];

  for (
    let index = shuffledItems.length - 1;
    index > 0;
    index -= 1
  ) {
    const randomIndex =
      Math.floor(Math.random() * (index + 1));

    [
      shuffledItems[index],
      shuffledItems[randomIndex]
    ] = [
      shuffledItems[randomIndex],
      shuffledItems[index]
    ];
  }

  return shuffledItems;
};
export const menu = [
  {
    id: "home",
    label: "Strona główna",
    to: "/",
    icon: "HomeIcon",
    megaMenu: null,
  },
  {
    id: "school",
    label: "Szkoła",
    showInFooter: true,
    footerOrder: 10,
    to: null,
    icon: null,
    megaMenu: {
      // title: "Szkoła",
      title: null,
      // viewAll: {
      //   label: "Strona główna",
      //   to: "/",
      // },
      // footer: {
      //   title: "Get started",
      //   description: "Explore our school portal",
      //   action: {
      //     label: "Open",
      //     to: "/start",
      //   },
      // },
      sections: [
        {
          id: "procedures",
          title: "Dokumenty i Procedury",
          links: [
            {
              id: "statutes",
              label: "Statuty",
              description: "Statuty CKZiU w Wyrzysku",
              to: "/statutes",
              icon: "BookOpenIcon",
              featured: false,
              external: false,
              order: 10,
            },
            {
              id: "standards",
              label: "Standardy",
              description: "Standardy Ochrony Małoletnich",
              to: "/standards",
              icon: "ClipboardCheckIcon",
              featured: false,
              external: false,
              order: 20,
            },
            {
              id: "rodo",
              label: "RODO",
              showInFooter: false,
              description: "Unijne prawo o ochronie danych osobowych",
              to: "/rodo",
              icon: "UserShieldIcon",
              featured: false,
              external: false,
              order: 30,
              showInFooter: true
            },
            {
              id: "accessibility",
              label: "Dostępność",
              description: "Dostępność informacyjno-komunikacyjna",
              to: "/accessibility",
              icon: "UniversalAccessIcon",
              featured: false,
              external: false,
              order: 40,
            },
            {
              id: "tenders",
              label: "Przetargi",
              description: "Zapytania ofertowe, przetargi",
              to: "/tenders",
              icon: "FileContractIcon",
              featured: false,
              external: false,
              order: 50,
            },
          ],
        },
        {
          id: "wsparcie",
          title: "Wsparcie",
          showInFooter: true,
          links: [
            {
              id: "pedagogue",
              label: "Pedagog",
              description: "Pedagog szkolny i specjalny",
              to: "/pedagogue",
              icon: "BookOpenIcon",
              featured: false,
              external: false,
              order: 10,
              showInFooter: false,
            },
            {
              id: "health",
              label: "Zdrowie",
              description: "Gabinet stomatologiczny",
              to: "/health",
              icon: "FirstAidIcon",
              featured: true,
              external: false,
              order: 20,
              showInFooter: false,
            },
            {
              id: "insurance",
              label: "Ubezpieczenia",
              description: "Warianty, Zasady, Warunki",
              to: "/insurance",
              icon: "ShieldAltIcon",
              featured: true,
              external: false,
              order: 30,
              showInFooter: true,
            },
          ],
        },
        {
          id: "projects",
          title: "Projekty",
          links: [
            {
              id: "erasmus",
              label: "Erasmus+",
              description: "Praktyki Zawodowe",
              to: "/projects/erasmus",
              icon: "BookOpenIcon",
              featured: true,
              external: false,
              order: 10,
              showInFooter: true,
            },
            {
              id: "projects-all",
              label: "Wszystkie projekty",
              description: "Aktualne i zakończone projekty szkoły",
              to: "/projects",
              icon: "FolderOpenIcon",
              featured: false,
              external: false,
              order: 20,
              showInFooter: false,
            }
          ],
        },
        {
          id: "absolwenci",
          title: "Absolwenci",
          showInFooter: false,
          links: [
            {
              id: "absolwenci",
              label: "Losy absolwentów",
              description: "Losy absolwentów",
              to: `${WORDPRESS_API}/wp-content/uploads/2026/08/Badanie-Losow-Absolwentow-ANKIETA.pdf`,
              icon: "BookOpenIcon",
              featured: true,
              external: true,
              order: 30,
            },
          ],
        },
      ],
    },
  },
  {
    id: "directions",
    label: "Oferta kształcenia",
    showInFooter: true,
    footerOrder: 10,
    to: null,
    icon: null,
    megaMenu: {
      title: null,
      footer: {
        title: "Informacje dla kandydatów",
        description: "Rekrutacja, terminy, podania i wymagane dokumenty",
        action: {
          label: "Zobacz",
          to: "/candidate",
        },
      },
      sections: [
        {
          id: "technical-school-directions",
          title: "Technikum",
          links: [
            ...shuffleItems([
            {
              id: "direction-ti",
              label: "Technik informatyk",
              description:
                "Komputery, systemy operacyjne, sieci i aplikacje internetowe",
              to: "/direction/ti",
              icon: "LaptopCodeIcon",
              featured: true,
              external: false,
              // order: 10,
              showInFooter: true,
            },
            {
              id: "direction-tp",
              label: "Technik programista",
              description:
                "Programowanie aplikacji, stron internetowych i baz danych",
              to: "/direction/tp",
              icon: "CodeIcon",
              featured: true,
              external: false,
              // order: 20,
              showInFooter: true,
            },
            {
              id: "direction-tz",
              label:
                "Technik żywienia i usług gastronomicznych",
              description:
                "Gastronomia, zdrowe żywienie i organizacja usług",
              to: "/direction/tz",
              icon: "GraduationCapIcon",
              featured: false,
              external: false,
              // order: 30,
              showInFooter: true,
            },
            ]),
            {
              id: "direction-th",
              label: "Technik hotelarstwa",
              description:
                "Obsługa gości, organizacja usług hotelarskich i turystyka",
              to: "/direction/th",
              icon: "GraduationCapIcon",
              featured: false,
              external: false,
              // order: 40,
              showInFooter: true,
            },
          ],
        },
        {
          id: "vocational-school-directions",
          title: "Szkoły branżowe",
          links: [
            {
              id: "direction-sw",
              label: "Branżowa szkoła I stopnia - wielozawodowa",
              description:
                "Praktyczna nauka zawodu w wybranej branży",
              to: "/direction/sw",
              icon: "GraduationCapIcon",
              featured: false,
              external: false,
              order: 10,
              showInFooter: true,
            },
            {
              id: "direction-pp",
              label: "Branżowa szkoła I stopnia - specjalna",
              description:
                "Pracownik pomocniczy stolarza lub fryzjera",
              to: "/direction/pp",
              icon: "GraduationCapIcon",
              featured: false,
              external: false,
              order: 20,
              showInFooter: true,
            },
            {
              id: "direction-bs2",
              label: "Branżowa szkoła II stopnia - zaoczna",
              description:
                "Technik handlowiec lub technik technologii żywności",
              to: "/direction/bs2",
              icon: "GraduationCapIcon",
              featured: false,
              external: false,
              order: 30,
              showInFooter: true,
            },
          ],
        },
        {
          id: "adult-education-directions",
          title: "Szkoła dla dorosłych",
          links: [
            {
              id: "direction-sd",
              label: "Liceum i szkoła policealna",
              description:
                "Wykształcenie średnie lub kwalifikacje zawodowe",
              to: "/direction/sd",
              icon: "GraduationCapIcon",
              featured: true,
              external: false,
              order: 10,
              showInFooter: true,
            }
          ],
        },
      ],
    },
  },
  {
    id: "candidate",
    label: "Kandydat",
    to: "/candidate",
    icon: null,
    megaMenu: null,
  },
  {
    id: "uczen",
    label: "Uczeń",
    showInFooter: true,
    footerOrder: 20,
    to: "/",
    icon: null,
    megaMenu: {
      title: null,
      sections: [
        {
          id: "Informacje-dla-ucznia",
          title: "Informacje dla ucznia",
          links: [
            {
              id: "egzaminy-poprawkowe",
              label: "Egzaminy poprawkowe",
              description: "Terminy egzaminów poprawkowych",
              to: "/student/retake-exams",
              icon: "ClipboardCheckIcon",
              featured: false,
              external: false,
              order: 10,
            },
            {
              id: "matura",
              label: "Egzamin maturalny",
              description: "Dokumenty i informacje dotyczące egzaminu maturalnego",
              to: "/student/matura",
              icon: "GraduationCapIcon",
              featured: false,
              external: false,
              order: 20,
            },
            {
              id: "podreczniki",
              label: "Podręczniki",
              description: "Aktualne zestawienie podręczników",
              to: `${WORDPRESS_API}/wp-content/uploads/2026/09/Wykaz-podrecznikow-2026-2027.pdf`,
              icon: "BookIcon",
              featured: false,
              external: true,
              order: 30,
            },
            {
              id: "documents",
              label: "Dokumenty",
              description: "Formularze, regulaminy i dokumenty związane z organizacją nauki",
              to: "/student/documents",
              icon: "FileContractIcon",
              featured: false,
              external: false,
              order: 40,
            },
            {
              id: "mLegitymacja",
              label: "mLegitymacja",
              description: "Legitymacja szkolna będąca częścią aplikacji mObywatel",
              to: "/student/mlegitymacja",
              icon: "IdCardIcon",
              featured: false,
              external: false,
              order: 50,
            },
          ],
        }
      ],
    },
  },
  {
    id: "parent",
    label: "Rodzic",
    to: "/parent",
    icon: null,
    megaMenu: null,
  },
  {
    id: "teacher",
    label: "Nauczyciel",
    to: "/teacher",
    icon: null,
    megaMenu: null,
  },
  {
    id: "edukacja",
    label: "Edukacja",
    showInFooter: false,
    footerOrder: 30,
    to: "/",
    icon: null,
    megaMenu: {
      title: null,
      // viewAll: {
      //   label: "View all",
      //   to: "/about",
      // },
      // footer: {
      //   title: "Get started",
      //   description: "Explore our school portal",
      //   action: {
      //     label: "Open",
      //     to: "/start",
      //   },
      // },
      sections: [
        {
          id: "platforma-edukacyjna",
          title: "Platforma edukacyjna CKZiU",
          logoId: "education-platform",
          links: [
            {
              id: "ti",
              label: "Technik Informatyk",
              description: "Arkusze, zbiory zadań, analizy",
              to: "/ckziu/ti/dashboard",
              icon: "LaptopCodeIcon",
              featured: false,
              external: false,
              order: 10,
            },
            {
              id: "tp",
              label: "Technik Programista",
              description: "Arkusze, zbiory zadań, analizy",
              to: "/ckziu/tp/dashboard",
              icon: "CodeIcon",
              featured: false,
              external: false,
              order: 20,
            },
          ],
        },
        {
          id: "instaling",
          title: "InstaLing",
          logoId: "instaling",
          links: [
            {
              id: "ti",
              label: "Język niemiecki",
              description: "Aplikacja do szybkiej nauki słówek",
              to: "https://instaling.pl/",
              icon: "LanguageIcon",
              featured: false,
              external: true,
              order: 10,
            },
            {
              id: "tp",
              label: "Język angielski",
              description: "Aplikacja do szybkiej nauki słówek",
              to: "https://instaling.pl/",
              icon: "LanguageIcon",
              featured: false,
              external: true,
              order: 20,
            },
          ],
        },
        {
        id: "teams",
        title: "Microsoft Teams",
        logoId: "teams",
        links: [
          {
            id: "teams-login",
            label: "Microsoft Teams",
            description: "Przejdź do platformy Microsoft Teams",
            to: "https://teams.microsoft.com/",
            icon: "ApplicationsIcon",
            external: true,
            order: 1,
          },
        ],
      },
      ],
    },
  },
  {
    id: "contact",
    label: "Kontakt",
    to: "/contact",
    icon: null,
    megaMenu: null,
  },
];
